module.exports = __webpack_public_path__ + "img/智能移动终端结构示意图.23c43f3e.jpg";